module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "dashboard-card md-layout-item md-size-50"
  }, [_c('md-card', [_c('md-card-header', [_c('div', {
    staticClass: "md-title",
    domProps: {
      "innerHTML": _vm._s(this.name)
    }
  })]), _vm._v(" "), _c('md-card-content', [(!_vm.loading && _vm.debtors.length) ? _c('md-list', {
    staticClass: "can-scroll"
  }, _vm._l((_vm.debtors), function(debtor) {
    return _c('md-list-item', {
      key: ("dashboard-debtor-" + (debtor.id))
    }, [_c('router-link', {
      staticClass: "md-list-item-text",
      attrs: {
        "to": {
          name: 'Customer',
          params: {
            customer_id: debtor.id
          }
        }
      }
    }, [_vm._v(_vm._s(debtor.name))]), _vm._v(" "), _c('span', {
      staticClass: "md-list-action"
    }, [_vm._v(_vm._s(((_vm.price.format(debtor.debt_sum)) + " руб.")))])], 1)
  })) : _vm._e(), _vm._v(" "), (!_vm.loading && !_vm.debtors.length) ? _c('div', [_vm._v("Должников не найдено")]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-129a7b76","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/finance/dashboard/DebtorsDashboard.vue
// module id = 1042
// module chunks = 0